import { type UpdateIntegrationSettings } from '@vy/types';
import { useQueryClient } from 'react-query';
import { queryKeys } from '../../../../../../../services/query-key/query-keys';
import { useUpdateIntegrationConfiguration } from '../../../../../../../hooks/requests/use-update-integration-configuration';
import { runMutation } from '../../../../../../../utils/vy-mutation';
import type { HandleUpdateConfigurationSuccess } from '../../../../../IntegrationProviderPage/integration-provider-page-components/ConfigurationTabContent/configuration-tab-content-types';

export function useModifyConfiguration(handleMutationSuccess?: HandleUpdateConfigurationSuccess) {
  const queryClient = useQueryClient();
  const updateConfigurationMutation = useUpdateIntegrationConfiguration();

  return async (integrationId: string, updatedIntegrationSettings: UpdateIntegrationSettings) => {
    await runMutation(
      updateConfigurationMutation,
      { integrationId, integrationSettings: updatedIntegrationSettings },
      {
        pending: `Updating ${updatedIntegrationSettings.integrationProvider} configuration...`,
        success: `${updatedIntegrationSettings.integrationProvider} configuration updated`,
        error: `Failed to update ${updatedIntegrationSettings.integrationProvider} configuration`,
      },
      {
        onSuccess: async (data) => {
          handleMutationSuccess?.(data);
          await queryClient.invalidateQueries(queryKeys.integrationSettings());
        },
      },
    );
  };
}
